import animateOnScroll from './animate-on-scroll'
// import runMenu from './menu'
import initSliders from './sliders';
import initSmoothScroll from './smooth-scroll';
import initHeader from './header';
import runAnimations from './animations';
import initFAQs from './faq';;

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  initSmoothScroll();
  animateOnScroll();
  runAnimations();
  initHeader();
  initSliders();
  initFAQs();
//   runMenu();

});

document.addEventListener("DOMContentLoaded", function () {
    function smoothScrollTo(target, duration = 800) {
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      let startTime = null;

      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
      }

      function ease(t, b, c, d) {
        // easeInOutQuad
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      }

      requestAnimationFrame(animation);
    }

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute("href"));
        if (target) {
          smoothScrollTo(target, 1200); 
        }
      });
    });
});


  
